/**
 * 内容管理
 */
export default {
  // 轮播图
  carouselInfodelete: "/carouselInfo/delete", // 删除/{id}
  carouselInfoinsert: "/carouselInfo/insert", // 新增
  carouselInfoselect: "/carouselInfo/select", // 查询
  carouselInfoupdate: "/carouselInfo/update", // 更新
  // 平台消息
  noticeInfodelete: "/noticeInfo/delete", // 删除/{id}
  noticeInfoinsert: "/noticeInfo/insert", // 新增
  noticeInfoselect: "/noticeInfo/select", // 查询
  noticeInfoupdate: "/noticeInfo/update", // 修改
  noticeInfoselectDetail: "/noticeInfo/selectDetail", // 查询详情
}
